import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { formatDate } from '@angular/common';
import { daysBetween, deepClone, } from '../../../../helpers/utils';
import { EmployeeReferralQueueModel, ReferralPayrollBonusModel } from '../../../../models/employeeReferralModel';
import { PagingResultsModel } from '../../../../models/pagingResultsModel';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { DropdownFilterService } from '../../../../core/services/dropdown-filter.service';
import { State } from '../../../../core/store';
import { tap } from 'rxjs';
import { loadEmployeeUsers, loadViewableCampuses } from '../../../../core/store/employee/employee.action';
import { awardReferralBonus, awardReferralBonusSuccess, deleteEmployeeReferral, deleteEmployeeReferralSuccess, deleteReferralBonus, deleteReferralBonusSuccess, getEmployeeReferralList, recalculateReferralBonus, recalculateReferralBonusSuccess, rejectEmployeeReferral, rejectEmployeeReferralSuccess, resetEmployeeReferral, resetEmployeeReferralSuccess, saveEmployeeReferralSuccess, showEditEmployeeReferral, toggleArchiveEmployeeReferral, toggleArchiveEmployeeReferralSuccess, createReferralFormSubmission, createReferralFormSubmissionSuccess } from '../../../../core/store/queues/queues.action';
import { AlertService } from '../../../../shared/services/alert.service';
import { ModifiedSelectItem, UserAutoCompleteItem } from '../../../../models/utilModels';


@Component({
  selector: 'app-referrals',
  templateUrl: './referrals.component.html',
  styleUrls: ['./referrals.component.scss'],
  standalone: false
})
export class ReferralsComponent extends BaseComponent implements OnInit {
  list: PagingResultsModel<EmployeeReferralQueueModel>;
  filter: any;
  loadingList: boolean = true;
  saving: boolean = false;
  canManage: boolean;

  campusList: ModifiedSelectItem[];
  campusId: number = 0;

  selectedReferredBy: UserAutoCompleteItem;
  selectedNewHire: UserAutoCompleteItem;
  userEmployeeList: UserAutoCompleteItem[];
  referredByPrefixText: string;
  referredByUserId: number = 0;
  newHirePrefixText: string;
  newHireUserId: number = 0;

  startDate: string = "";
  endDate: string = formatDate(new Date(), 'yyyy-MM-dd', 'en-US');

  yesNoAllOptions = [
    { label: 'All', value: null },
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];

  terminatedEmployeesFilter?: boolean = false;
  inactiveUsersFilter?: boolean = false;
  archivedReferralsFilter?: boolean = false;
  prospectiveCandidatesFilter?: boolean = false;
  rejectedReferralsFilter?: boolean = false;


  constructor(
    private router: Router,
    private actions$: Actions,
    private store: Store<State>,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private dropdownFilterService: DropdownFilterService) {
    super();
  }

  ngOnInit(): void {
    this.subs.push(
      this.store.select(s => s.employeeState.campuses).subscribe(campuses => {
        this.campusList = campuses && campuses.length > 0 ? campuses
          : [{ label: 'loading...', value: undefined }];
      }),
      this.store.select(s => s.employeeState.employeeUsers).subscribe(users => {
        this.userEmployeeList = users.map(x => ({
          id: x.value,
          name: x.label
        }));
      }),
      this.store.select(s => s.queuesState.loadingEmployeeReferralList).subscribe(loadingEmployeeReferralList => {
        this.loadingList = loadingEmployeeReferralList;
      }),
      this.store.select(s => s.queuesState.savingReferralBonus).subscribe(savingReferralBonus => {
        this.saving = savingReferralBonus;
      }),
      this.store.select(s => s.queuesState.employeeReferralList).subscribe(employeeReferralList => {
        this.list = deepClone(employeeReferralList);
      }),     
      this.store.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        this.canManage = permissionIDs && !!permissionIDs.find(p => p === 3306);
      }),
      this.actions$.pipe(
        ofType(saveEmployeeReferralSuccess),
        tap(action => {
          this.reloadList();
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(awardReferralBonusSuccess),
        tap(action => {
          this.alertService.success("Referral bonus saved");
          this.reloadList();
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(createReferralFormSubmissionSuccess),
        tap(action => {
          this.alertService.success("Referral form created");
          this.reloadList();
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(recalculateReferralBonusSuccess),
        tap(action => {
          this.alertService.success("Referral bonus recalculated");
          this.reloadList();
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(deleteReferralBonusSuccess),
        tap(action => {
          this.alertService.success("Referral bonus deleted");
          this.reloadList();
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(deleteEmployeeReferralSuccess),
        tap(action => {
          this.reloadList();
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(toggleArchiveEmployeeReferralSuccess),
        tap(action => {
          this.reloadList();
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(resetEmployeeReferralSuccess),
        tap(action => {
          this.reloadList();
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(rejectEmployeeReferralSuccess),
        tap(action => {
          this.reloadList();
        })
      ).subscribe(),
    );

    this.store.dispatch(loadViewableCampuses());
  }

  reloadFilter(event) {
    this.filter = event;
    this.reloadList();
  }

  reloadList() {
    this.filter = deepClone(this.filter);
    this.filter.filters.referredByUserId = { Name: 'referredByUserId', Value: { value: this.referredByUserId.toString() } };
    this.filter.filters.newHireUserId = { Name: 'newHireUserId', Value: { value: this.newHireUserId.toString() } };
    this.filter.filters.campusId = { Name: 'campusId', Value: { value: this.campusId.toString() } };
    this.filter.filters.startDate = { Name: 'startDate', Value: { value: this.startDate } };
    this.filter.filters.endDate = { Name: 'endDate', Value: { value: this.endDate } };
    this.filter.filters.showTerminatedEmployees = { Name: 'showTerminatedEmployees', Value: { value: this.terminatedEmployeesFilter } };
    this.filter.filters.showInactiveUsers = { Name: 'showInactiveUsers', Value: { value: this.inactiveUsersFilter } };
    this.filter.filters.showRejectedReferrals = { Name: 'showRejectedReferrals', Value: { value: this.rejectedReferralsFilter } };
    this.filter.filters.showArchivedReferrals = { Name: 'showArchivedReferrals', Value: { value: this.archivedReferralsFilter } };
    this.filter.filters.showProspectiveCandidates = { Name: 'showProspectiveCandidates', Value: { value: this.prospectiveCandidatesFilter } };

    this.store.dispatch(getEmployeeReferralList({
      filter: this.filter
    }));
  }

  getStaffList(event) {
    this.store.dispatch(loadEmployeeUsers({
      prefixText: event.query,
      campusId: this.campusId,
      payrollClassificationId: null,
      showInactive: this.inactiveUsersFilter !== false ? true : false,
      showTerminated: this.terminatedEmployeesFilter !== false ? true : false
    }));
  }

  reloadListAfterReferredByStaffChage(selectedUser) {
    if (typeof selectedUser.value.id !== 'number') {
      return;
    }

    this.referredByUserId = selectedUser.value.id;
    this.reloadList();
  }

  reloadListAfterReferredByClear(event) {    
    this.referredByUserId = 0;
    this.reloadList();
  }

  reloadListAfterNewHireStaffChage(selectedUser) {
    if (typeof selectedUser.value.id !== 'number') {
      return;
    }

    this.newHireUserId = selectedUser.value.id;
    this.reloadList();
  }

  reloadListAfterNewHireClear(event) {   
    this.newHireUserId = 0;
    this.reloadList();
  }

  showCreateFormButton(referral: EmployeeReferralQueueModel) {
    if (referral.formSubmissionID > 0) {
      return false;
    }

    return referral.hasDefaultForm;
  }

  getFormDetails(referral: EmployeeReferralQueueModel) {
    if (referral.formSubmissionID > 0) {

      if (referral.formSignedDate != null) {
        return ""; //form is signed, no explanation necessary
      }

      return "Form not signed";
    }

    if (referral.hasDefaultForm) {
      return "Form not created";
    }

    return "No default form";
  }

  hasSignedForm(referral: EmployeeReferralQueueModel) {
    return referral.formSubmissionID > 0 && referral.formSignedDate != null;
  }

  viewForm(referral: EmployeeReferralQueueModel) {
    if (referral.formSubmissionID > 0) {
      const url = this.router.serializeUrl(this.router.createUrlTree(['../../form-filling/form-submission/0/' + referral.formSubmissionID], { relativeTo: this.route }));

      window.open(url, "_blank");
    }
  }

  getNewHireDaysAfterHire(referral) {
    if (referral.newHireTrainingStartDate != null) {
      return " (" + daysBetween(new Date(referral.newHireTrainingStartDate), new Date()) + ")";
    }

    return "";
  }

  getNewHireDetailsString(referral) {
    if (referral.newHireUserID == null || referral.newHireUserID <= 0) {
      return "(Not Hired)";
    }

    if (referral.newHireTerminationDate != null) {
      return "(Separated)";
    }

    if (referral.newHireInactive) {
      return "(Inactive)"
    }

    return "";
  }

  getReferredByTerminationString(referral) {
    if (referral.referredByTerminationDate != null) {
      return "(Separated)";
    }

    if (referral.referredByInactive) {
      return "(Inactive)"
    }

    return "";
  }

  getOversightReviewTitle(oversightReview) {
    if (oversightReview == null || oversightReview.templateDescription == null) {
      return "";
    }

    return oversightReview.templateDescription;
  }

  getOversightReviewScoreTitle(oversightReview) {
    var titleString = "Exceeds max score";

    if (oversightReview != null && oversightReview.maxScore != null) {
      titleString += " of " + oversightReview.maxScore;
    }

    return titleString;
  }

  addNewReferral() {
    this.store.dispatch(showEditEmployeeReferral({ referralId: 0, prospectiveCandidate: null }));
  }

  editReferral(referral: EmployeeReferralQueueModel) {
    this.store.dispatch(showEditEmployeeReferral({ referralId: referral.id > 0 ? referral.id : 0, prospectiveCandidate: null }));
  }

  addReferralBonus(referral: EmployeeReferralQueueModel) {
    this.store.dispatch(awardReferralBonus({ referralId: referral.id }));
  }

  redoReferralBonus(bonus: ReferralPayrollBonusModel) {
    this.store.dispatch(recalculateReferralBonus({ payrollBonusId: bonus.payrollBonusId }));
  }

  removeReferralBonus(bonus: ReferralPayrollBonusModel) {
    this.store.dispatch(deleteReferralBonus({ payrollBonusId: bonus.payrollBonusId }));
  }

  createReferralForm(referral: EmployeeReferralQueueModel) {
    this.store.dispatch(createReferralFormSubmission({ referralId: referral.id }));
  }

  deleteReferral(referral: EmployeeReferralQueueModel) {
    this.alertService.confirm('Delete Referral',
      'Are you sure you want to delete this referral? It will be archived if it can not be deleted. Deleting can NOT be undone.')
      .subscribe(
        answer => {
          if (answer) {
            this.store.dispatch(deleteEmployeeReferral({ referralId: referral.id }));
          }
        }, error => {
        }
      );
  }

  toggleArchived(referral: EmployeeReferralQueueModel) {
    this.store.dispatch(toggleArchiveEmployeeReferral({ referralId: referral.id, reason: referral.archivedReason }));
  }

  toggleArchivedReason(referral: EmployeeReferralQueueModel) {
    referral.showArchivedReason = !referral.showArchivedReason;
    referral.showRejectionReason = false;
  }

  toggleRejectionReason(referral: EmployeeReferralQueueModel) {
    referral.showRejectionReason = !referral.showRejectionReason;
    referral.showArchivedReason = false;
  }

  rejectReferralBonus(referral: EmployeeReferralQueueModel) {
    this.store.dispatch(rejectEmployeeReferral({ referralId: referral.id, reason: referral.rejectionReason }));
  }

  resetReferralBonus(referral: EmployeeReferralQueueModel) {
    this.store.dispatch(resetEmployeeReferral({ referralId: referral.id }));
  }
}
